const REASON_COPY: Record<string, string> = {
  // Webhook DeliveryReason slugs (apps/webhooks/services/webhook_delivery.py).
  non_2xx: 'the endpoint returned an error response',
  network_error: "couldn't reach the endpoint",
  payload_too_large: 'the payload was too large to send',
  non_https: "the destination URL isn't secure (HTTPS)",
  ssrf: "the destination address isn't allowed",
  config_error: 'the endpoint is misconfigured',
  invalid_auth_method: "the authentication method isn't valid",
  no_secret: 'no signing secret is set',
  exhausted: 'all retries were used up',
  internal_error: 'an internal error occurred',
  disabled: 'the endpoint is turned off',
  missing_destination_url: 'no destination URL is set',
  org_deactivated: 'the workspace is deactivated',
  // Platform terminal reasons (DispatchError.reason in
  // apps/outbound_channels/services/channel_delivery_types.py) — carried on ahoy_outbound_failed.
  send_disabled:
    "sending through this channel isn't available in your workspace yet",
  channel_disabled: 'outbound is off for this channel',
  channel_paused_mid_flight:
    'outbound was paused while this message was sending',
  channel_unreadable: "we couldn't read this channel",
  channel_not_connected: "this channel isn't connected",
  mailbox_not_found: "we couldn't find the connected mailbox – reconnect it",
  duplicate_inflight: 'an identical send was already in progress',
  provider_terminal_error: 'the provider rejected the message',
  retries_exhausted: 'all retries were used up',
  delivery_unknown: "we couldn't confirm it was delivered",
  payload_invalid: "the message couldn't be prepared",
  // Webhook adapter retry reasons — carried on ahoy_outbound_attempt_failed.
  endpoint_resolution_transient: "couldn't look up the endpoint configuration",
  // Email retry reasons — carried on ahoy_outbound_attempt_failed.
  provider_transient: 'the provider was temporarily unavailable',
  provider_rate_limited: 'the provider is limiting sends',
  provider_auth: 'the mailbox connection needs refreshing – reconnect it',
};

// Maps a terminal `failed`-reason (a DispatchError platform reason) or an
// `attempt_failed`-reason (a webhook DeliveryReason slug or an email retry
// slug) to human-readable copy. Returns undefined for success (2xx), unknown
// slugs, and absent/blank input so callers can render a generic fallback
// without leaking internal slug names.
export function outboundOutcomeReason(
  lastError?: string | null
): string | undefined {
  if (!lastError || !lastError.trim() || lastError === '2xx') {
    return undefined;
  }
  // Guard the lookup with Object.hasOwn so an inherited prototype key such as
  // "constructor" or "toString" resolves to undefined (generic fallback) rather
  // than an inherited function that would render as bogus copy.
  return Object.hasOwn(REASON_COPY, lastError)
    ? REASON_COPY[lastError]
    : undefined;
}
